import React from 'react';
import {Radio} from 'material-ui';

export default function RatingSelectable({
	src,
	value,
	label,
	selectedValue,
	onChange,
}) {
	return (
		<div className='ratingSelectable'>
			<img className='levelImg' src={src} />
			<p>{label}</p>
			<Radio
				disableRipple={true}
				value={value}
				checked={value === selectedValue}
				onChange={() => onChange(value)}
			/>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/rating/RatingSelectable.js